"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MoonBoard = void 0;
var vue_1 = require("vue");
var SpaceType_1 = require("../../SpaceType");
var MoonSpace_1 = require("./MoonSpace");
var MoonParamLevel = (function () {
    function MoonParamLevel(value, isActive, strValue) {
        this.value = value;
        this.isActive = isActive;
        this.strValue = strValue;
    }
    return MoonParamLevel;
}());
exports.MoonBoard = vue_1.default.component('moonboard', {
    props: {
        model: {
            type: Object,
        },
    },
    components: {
        'moon-space': MoonSpace_1.MoonSpace,
    },
    data: function () {
        return {};
    },
    methods: {
        getAllNonColonySpaces: function () {
            var boardSpaces = this.model.spaces;
            boardSpaces.sort(function (space1, space2) {
                return parseInt(space1.id) - parseInt(space2.id);
            });
            return boardSpaces.filter(function (s) {
                return s.spaceType !== SpaceType_1.SpaceType.COLONY;
            });
        },
        getSpaceById: function (spaceId) {
            for (var _i = 0, _a = this.model.spaces; _i < _a.length; _i++) {
                var space = _a[_i];
                if (space.id === spaceId) {
                    return space;
                }
            }
            throw 'Board space not found by id \'' + spaceId + '\'';
        },
        getValuesForParameter: function (targetParameter) {
            var curValue;
            switch (targetParameter) {
                case 'logistics':
                    curValue = this.model.logisticsRate;
                    break;
                case 'mining':
                    curValue = this.model.miningRate;
                    break;
                case 'colony':
                    curValue = this.model.colonyRate;
                    break;
                default:
                    throw 'Wrong parameter to get values from';
            }
            var values = [];
            for (var value = 8; value >= 0; value -= 1) {
                var strValue = value.toString();
                values.push(new MoonParamLevel(value, value === curValue, strValue));
            }
            return values;
        },
        getScaleCSS: function (paramLevel) {
            var css = 'global-numbers-value val-' + paramLevel.value + ' ';
            if (paramLevel.isActive) {
                css += 'val-is-active';
            }
            return css;
        },
    },
    template: "\n    <div class=\"board-cont moon-board\" id=\"moon_board\">\n      <svg id=\"moon_board_legend\" height=\"550\" width=\"630\" class=\"board-legend\">\n        <g id=\"mare_imbrium\" transform=\"translate(250, 40)\">\n          <text class=\"board-caption\">\n            <tspan dy=\"15\">Mare</tspan>\n            <tspan x=\"12\" dy=\"12\">Imbrium</tspan>\n          </text>\n          <line x1=\"24\" y1=\"34\" x2=\"33\" y2=\"105\" class=\"board-line\"></line>\n          <text x=\"30\" y=\"107\" class=\"board-caption board_caption--black\">\u25CF</text>\n        </g>\n\n        <g id=\"mare_sereitatis\" transform=\"translate(485, 140)\">\n          <text class=\"board-caption\">\n              <tspan dy=\"15\">Mare</tspan>\n              <tspan x=\"4\" dy=\"12\">Serenitatis</tspan>\n          </text>\n          <line x1=\"0\" y1=\"25\" x2=\"-120\" y2=\"50\" class=\"board-line\"></line>\n          <text x=\"-122\" y=\"53\" class=\"board-caption board_caption--black\">\u25CF</text>\n        </g>\n\n\n        <g id=\"mare_nubium\" transform=\"translate(195, 350)\">\n          <text class=\"board-caption\">\n            <tspan dy=\"15\">Mare</tspan>\n            <tspan x=\"-2\" dy=\"12\">Nubium</tspan>\n          </text>\n          <line x1=\"29\" y1=\"14\" x2=\"115\" y2=\"-64\" class=\"board-line\"></line>\n          <text x=\"113\" y=\"-62\" class=\"board-caption board_caption--black\">\u25CF</text>\n        </g>\n\n        <g id=\"mare_nectaris\" transform=\"translate(450, 300)\">\n          <text class=\"board-caption\" dx=\"47\">\n            <tspan dy=\"15\">Mare</tspan>\n            <tspan dy=\"12\" x=\"48\">Nectaris</tspan>\n          </text>\n          <line x1=\"-39\" y1=\"-12\" x2=\"45\" y2=\"15\" class=\"board-line\"></line>\n          <text x=\"-39\" y=\"-9\" class=\"board-caption board_caption--black\">&#x25cf;</text>\n        </g>\n      </svg>\n\n      <div class=\"board-outer-spaces\">\n        <moon-space :space=\"getSpaceById('m01')\" text=\"Luna Trade Station\"></moon-space>\n        <moon-space :space=\"getSpaceById('m37')\" text=\"Momentum Virium Habitat\"></moon-space>\n      </div>\n\n      <div class=\"global-numbers\">\n        <div class=\"global-numbers-colony\">\n          <div :class=\"getScaleCSS(lvl)\" v-for=\"lvl in getValuesForParameter('colony')\">{{ lvl.strValue }}</div>\n        </div>\n\n        <div class=\"global-numbers-logistics\">\n          <div :class=\"getScaleCSS(lvl)\" v-for=\"lvl in getValuesForParameter('logistics')\">{{ lvl.strValue }}</div>\n        </div>\n\n        <div class=\"global-numbers-mining\">\n          <div :class=\"getScaleCSS(lvl)\" v-for=\"lvl in getValuesForParameter('mining')\">{{ lvl.strValue }}</div>\n        </div>\n\n      </div>\n\n      <div class=\"board\" id=\"moon_board\">\n        <moon-space :space=\"curSpace\" :is_selectable=\"true\" :key=\"'moon-space-'+curSpace.id\" v-for=\"curSpace in getAllNonColonySpaces()\"></moon-space>\n      </div>\n    </div>\n    ",
});
//# sourceMappingURL=MoonBoard.js.map